import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

/**
 * Generikus atomFamily bármilyen értékhez dinamikus kulccsal.
 * A useOcClientState hook belső state-je.
 *
 * A default értéket undefined-ra állítjuk, mert az inicializálást
 * a hook végzi el a kapott initialValue alapján.
 */
export const ocClientState = atomFamily<unknown, string>({
  key: "ocClientState",
  default: undefined,
  effects_UNSTABLE: [ocPersistAtom],
});
